import React from 'react';
import { find, sumBy } from 'lodash';

import { DonutChart } from '@magoosh/lib/charts';
import { pluralize } from 'utilities/pluralize';
import { minutesFormattedAsShortString } from 'utilities/time';

import StatisticData from '../statistic_data';

import colors from '@magoosh/lib/styles/colors.module.scss';

interface Props {
  filters: any;
}

const FlashcardsMasteredChart: React.FC<Props> = (props) => {
  const loadingPlaceholder = (
    <DonutChart
      chartProps={{ animate: false }}
      // TODO - Make placeholder labels below exam agnostic
      data={[
        { color: colors.gray85, label: 'Math Mastered', value: 40 },
        { color: colors.grayLighter, label: 'Vocabulary Mastered', value: 30 }
      ]}
      legendPosition="bottom"
      size={150}
    />
  );

  const formatStatisticData = (statisticData) => {
    return statisticData.map((datum) => (
      { label: datum.name, value: datum.value }
    ));
  };

  const formatValue = (value) => {
    return pluralize(value, 'card');
  };

  if (!props.filters) {
    return loadingPlaceholder;
  } else {
    return (
      <StatisticData
        filters={props.filters}
        formatDataFn={formatStatisticData}
        name="flashcards_mastered"
      >
        <StatisticData.Loading>
          {loadingPlaceholder}
        </StatisticData.Loading>

        {/* @ts-ignore */}
        <DonutChart
          chartProps={{ animate: false }}
          interior={(data) => (
            <strong>
              <span style={{ color: colors.dataDarkBlue, fontSize: 150 * 0.25 }}>
                {sumBy(data, 'value')}
              </span>
            </strong>
          )}
          formatValueFn={formatValue}
          legendPosition="bottom"
          size={150}
        />
      </StatisticData>
    );
  }
};

export default FlashcardsMasteredChart;
